import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"

type DataDisposalType = {
    acquisition_cost: number,
    depreciation_accumulation: number,
    betbook: number,
    disposal: boolean,
    disposal_date: string,
    disposal_value: number,
    disposal_memo: string,
    coa_asset_id: number,
    coa_asset_code: string,
    coa_asset_name: string,
    coa_disposal_id: number,
    coa_disposal_code: string,
    coa_disposal_name: string,
}

export const useDataUsage = ({ assetId }: { assetId: number}) => {
  const api = useApi()
  const [data, setData] = useState<DataDisposalType | null>(null)
  const [isLoading, setLoading] = useState(true)

  const fetching = () => {
    api.get(`/assetdepre/get_data_usage?asset_id=${assetId}`)
    .then((res: SuccessFetch<{ payload: DataDisposalType
        }>) => {
  
      setData(res.data.payload)
    })
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  const refecth = () => fetching()

  useEffect(() => {
    fetching()

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [assetId])

  return { data, isLoading, refecth }
}